// material-ui

import trailerblicon from '../../../assets/images/trailer-bl-icon.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const TrailerBlIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={trailerblicon} alt="Trailer" width="25"  />
    );
};

export default TrailerBlIcon;


